import {FieldProps} from 'formik';
import {DateTimePicker, DateTimePickerProps} from '@mantine/dates';

export const TimestampInput = ({
                                   field,
                                   form,
                                   ...rest
                               }: FieldProps & DateTimePickerProps) => {

    const dateValue = field.value ? new Date(field.value * 1000) : null;

    return (
        <DateTimePicker
            {...rest}
            value={dateValue}
            onChange={(value: Date | null) => {
                const timestamp = value ? Math.floor(value.getTime() / 1000) : undefined;
                form.setFieldValue(field.name, timestamp);
            }}
            onBlur={() => form.setFieldTouched(field.name, true)}
            error={form.touched[field.name] && form.errors[field.name] ? form.errors[field.name] as string : undefined}
        />
    );
};
